/**
 * Composant AvoirDialog - Dialogue pour générer un avoir partiel
 */

import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import { FileOutput } from 'lucide-react';

export const AvoirDialog = ({
  open,
  onOpenChange,
  selectedDevis,
  avoirData,
  setAvoirData,
  onGenerateAvoir
}) => {
  const maxMontant = selectedDevis?.payeur_montant || selectedDevis?.montant_total || 99999;
  const isInvalid = avoirData.montant <= 0 || (selectedDevis && avoirData.montant > maxMontant);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="avoir-dialog">
        <DialogHeader>
          <DialogTitle className="text-amber-600 flex items-center gap-2">
            <FileOutput className="h-5 w-5" />
            Générer un avoir partiel
          </DialogTitle>
          <DialogDescription>
            {selectedDevis && (
              <span>
                {selectedDevis.payeur_type && <><strong>{selectedDevis.payeur_type}</strong> - </>}
                Facture: <strong>{selectedDevis.facture_numero || selectedDevis.devis_id?.slice(0, 8)}</strong>
                <br />
                Montant {selectedDevis.payeur_type || 'facture'}: <strong>{(selectedDevis.payeur_montant || selectedDevis.montant_total)?.toLocaleString('fr-FR')} €</strong>
              </span>
            )}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="avoir-montant">Montant de l'avoir (€)</Label>
            <Input
              id="avoir-montant"
              type="number"
              step="0.01"
              min="0.01"
              max={maxMontant}
              value={avoirData.montant}
              onChange={(e) => setAvoirData({...avoirData, montant: parseFloat(e.target.value) || 0})}
              placeholder="0.00"
              className="text-lg font-semibold"
              data-testid="input-avoir-montant"
            />
            {selectedDevis && avoirData.montant > maxMontant && (
              <p className="text-xs text-red-500">Le montant ne peut pas dépasser le montant de la facture</p>
            )}
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="avoir-motif">Motif (optionnel)</Label>
            <Input
              id="avoir-motif"
              type="text"
              value={avoirData.motif}
              onChange={(e) => setAvoirData({...avoirData, motif: e.target.value})}
              placeholder="Ex: Remise commerciale, Erreur de facturation..."
              data-testid="input-avoir-motif"
            />
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button
            className="bg-amber-500 hover:bg-amber-600"
            disabled={isInvalid}
            onClick={onGenerateAvoir}
            data-testid="btn-generate-avoir"
          >
            <FileOutput className="h-4 w-4 mr-2" />
            Générer l'avoir
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AvoirDialog;
